import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../api/AuthContext.jsx';
import rbac from '../../backend/rbac/rbacService.js';

// RouteGuard: lightweight wrapper to protect routes progressively.
// Usage: <Route element={<RouteGuard requiredRole={ROLES.INCIDENT_COMMANDER}><IncidentPage/></Route>} />

export const RouteGuard = ({ children, requiredRole, allowedRoles, accessCheck }) => {
    const { user, isLoadingAuth } = useAuth();
    const location = useLocation();

    if (isLoadingAuth) return children; // don't block during initial loading

    // If no user, redirect to login page non-aggressively
    if (!user) {
        const next = `${location.pathname}${location.search || ''}`;
        return <Navigate to={`/Landing?next=${encodeURIComponent(next)}`} replace />;
    }

    if (Array.isArray(allowedRoles) || typeof accessCheck === 'function') {
        if (rbac.hasAnyRole(user, allowedRoles) || accessCheck?.(user)) return children;
        return (
            <div style={{ padding: 24 }}>
                <div className="lcars-panel" style={{ padding: 20 }}>
                    <h3>Acesso Negado</h3>
                    <p>Seu usuário não possui permissão para acessar este módulo.</p>
                </div>
            </div>
        );
    }

    // If no specific role required, allow access
    if (!requiredRole) return children;

    const allowed = rbac.hasRole(user, requiredRole) || rbac.isOperationalRole(user);

    if (!allowed) {
        // Render a safe fallback: show access-denied placeholder without breaking layout
        return (
            <div style={{ padding: 24 }}>
                <div className="lcars-panel" style={{ padding: 20 }}>
                    <h3>Accesso Negado</h3>
                    <p>Seu usuário não possui permissão para acessar este módulo.</p>
                </div>
            </div>
        );
    }

    return children;
};

export default RouteGuard;
